export default {
  logEnable: true,
  max: 500,
};